import React, { useEffect, useState } from 'react';

// third-party imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

// project-imports
import EBookListingHomeStencil from '../ebooks/EBookListingHomeStencil';
import EBookListingHome from '../ebooks/EBookListingHome';
import { Link } from 'react-router-dom';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { useProductContext } from '../../context/product_context';
import ErrorComponent from '../error-message/ErrorComponent';


const SalesforceEbookV2 = ({ data, isFromHome, productLoading, activeStatus, title, subText }) => {

    const { productsError } = useProductContext();

    // State initialization;
    const [showSlider, setShowSlider] = useState(false);

    // Data sorting
    const sortedData = [...data].sort(
        (a, b) =>
            new Date(b.metadata?.createdAt) - new Date(a.metadata?.createdAt)
    );

    useEffect(() => {
        setShowSlider(true);
    }, []);

    if (productLoading) {
        // Loading stencil 
        return <EBookListingHomeStencil />
    }

    return (
        <>
            <div className="edu-course-area eduvibe-home-two-course edu-section-gap bg-color-white">
                <div className="container eduvibe-animated-shape">
                    <div className="row g-5 y-gap-15 align-items-center justify-content-between">
                        <div className="col-12 col-lg-6">
                            <div className="section-title text-start">
                                <span className="pre-title">
                                    {subText}
                                </span>
                                <h3 className="title">{title}</h3>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="load-more-btn">
                                <Link className="button -icon -outline-purple-1 color-primary"
                                    to="/our-resources/paid"
                                    onClick={() =>
                                        triggerFunction(
                                            GoogleAnalyticsEnum.BUTTON,
                                            GoogleAnalyticsEnum.SALESFORCE_ALL_EBOOKS,
                                        )
                                    }
                                >
                                    View All E-Books<i class="ri-arrow-right-up-line ml--10"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row y-gap-30 pt--50">
                        {(!productLoading && productsError) ?
                            <div className="row g-5 mt--10 text-center">
                                <ErrorComponent errorCode="500" mainError={`No ebooks are available!`} subText={`Currently no ebooks are available. Please be back later.`} buttonText="Back to Home" link='/' />
                            </div>
                            :
                            (!productLoading && !productsError && data && !data.length) ?
                                // <ErrorComponent errorCode="404" mainError="Oops...! No Courses are available." />
                                <ErrorComponent errorCode="404" mainError={`Failed to get ebooks right now.`} subText="Please return to the site's homepage, It looks like nothing was found at this location" buttonText="Back to Home" link='/' />
                                :
                                <>
                                    <div
                                        className="overflow-hidden js-section-slider"
                                        data-loop
                                        data-gap="30"
                                        data-pagination
                                        data-slider-cols="xl-6 lg-6 md-4 sm-3 base-2"
                                    >
                                        {showSlider && (
                                            <Swiper
                                                // {...setting}

                                                modules={[Navigation, Pagination]}
                                                pagination={{
                                                    el: ".books-pagination",
                                                    clickable: true,
                                                }}
                                                navigation={{
                                                    nextEl: ".books-next",
                                                    prevEl: ".books-prev",
                                                }}
                                                spaceBetween={30}
                                                slidesPerView={2}
                                                breakpoints={{
                                                    // when window width is >= 576px
                                                    450: {
                                                        slidesPerView: 3,
                                                    },
                                                    // when window width is >= 768px
                                                    768: {
                                                        slidesPerView: 4,
                                                    },
                                                    1200: {
                                                        // when window width is >= 992px
                                                        slidesPerView: 6,
                                                    },
                                                }}
                                                loop={true}
                                            >
                                                {(sortedData || [])?.map((item, i) => (
                                                    <SwiperSlide key={i}>
                                                        <EBookListingHome isFromHome={isFromHome} data={item} activeStatus={activeStatus} />
                                                    </SwiperSlide>
                                                    // 140,90
                                                ))}
                                            </Swiper>
                                        )}

                                        <div className="d-flex align-items-center justify-content-center pt--60 lg:pt--40 gap-3">
                                            <div className="col-auto">
                                                <Link className="d-flex items-center text-24 arrow-left-hover js-prev books-prev">
                                                    <FaArrowLeft />
                                                </Link>
                                            </div>
                                            <div className="col-auto">
                                                <div className="pagination -arrows js-pagination books-pagination pagination-white-dot-dark"></div>
                                            </div>
                                            <div className="col-auto">
                                                <Link className="d-flex items-center text-24 arrow-right-hover js-next books-next">
                                                    <FaArrowRight />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </>
                        }

                    </div>
                </div>
            </div>
        </>
    )
}

export default SalesforceEbookV2;